export * from './amount-of-characters-validator';
export * from './custom-mask-validator';
export * from './collection';
export * from './date';

export function deserialize<T>(value: string | T) : T{
  return typeof value === 'string'
    ? JSON.parse(value)
    : value;
}
